import React, {Component} from 'react';
import ContactForm from '../presentational/ContactForm';
import SectionText from '../presentational/SectionText';

import data from '../../core/data';

class ContactFormContainer extends Component {
  render() {
    return (
      <section id="contact">
        <div className="container">
          <h1 className="header">Find your nearest treatment clinic</h1>
          <p>The <b>Herbal Aktiv Peel</b>® is performed by specially trained aestheticians in a professional environment. If required treatments can be repeated in 4-weekly intervals. Your aesthetician will keep a photographic record of your progress with this outstanding skin resurfacing treatment. To find your nearest qualified aesthetician please enquire using the form below. Alternatively please call our office on 1300 301 007.</p>
          <div className="alert" id="response" role="alert"></div>
          <ContactForm />
        </div>
      </section>
    )
  }
}

export default ContactFormContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/ContactFormContainer.jsx
 **/